import { CONNECTION } from "../../config/Connections";
import { CONFIG_ } from "../../config/Config";

var get = "/modul";
var post = "/modul";
export const actGetDataModul = () => {
  return dispatch => {
    let config = CONFIG_({ url: get, method: "GET" });
    dispatch({ type: "LOADING_MODUL_MODUL" });
    CONNECTION(config)
      .then(response => {
        const { status, data } = response;
        if (status === 200) {
          return dispatch({
            type: "SUCCESS_MODUL_MODUL",
            message: "Success get data",
            data: data,
            code: status
          });
        }
        return dispatch({ type: "ERROR_MODUL_MODUL", message: "failed" });
      })
      .catch(response => {
        console.log(response);
        return dispatch({
          type: "ERROR_MODUL_MODUL",
          message: "Network error.."
        });
      });
  };
};

export const actPostDataModul = params => {
  return dispatch => {
    let config = CONFIG_({ url: post, data: params, method: "POST" });
    dispatch({ type: "LOADING_MODUL_MODUL" });
    CONNECTION(config)
      .then(response => {
        const { status } = response;
        if (status === 200) {
          return dispatch(actGetDataModul());
        }
        return dispatch({ type: "ERROR_MODUL_MODUL", message: "failed" });
      })
      .catch(response => {
        console.log(response);
        return dispatch({
          type: "ERROR_MODUL_MODUL",
          message: "Network error.."
        });
      });
  };
};

export const actUpdateDataModul = params => {
  return dispatch => {
    const { id } = params;
    let config = CONFIG_({ url: post + "/" + id, data: params, method: "PUT" });
    dispatch({ type: "LOADING_MODUL_MODUL" });
    CONNECTION(config)
      .then(response => {
        const { status } = response;
        if (status === 200) {
          return dispatch(actGetDataModul());
        }
        return dispatch({ type: "ERROR_MODUL_MODUL", message: "failed" });
      })
      .catch(response => {
        console.log(response);
        return dispatch({
          type: "ERROR_MODUL_MODUL",
          message: "Network error.."
        });
      });
  };
};

export const actDetailDataModul = params => {
  return dispatch => {
    const { id } = params;
    let config = CONFIG_({ url: post + "/" + id, method: "GET" });
    dispatch({ type: "LOADING_MODUL_MODUL" });
    CONNECTION(config)
      .then(response => {
        const { status } = response;
        if (status === 200) {
          return dispatch({
            type: "SUCCESS_MODUL_MODUL",
            message: "Success get data"
          });
        }
        return dispatch({ type: "ERROR_MODUL_MODUL", message: "failed" });
      })
      .catch(response => {
        console.log(response);
        return dispatch({
          type: "ERROR_MODUL_MODUL",
          message: "Network error.."
        });
      });
  };
};

export const actDeleteDataModul = params => {
  return dispatch => {
    const { id } = params;
    let config = CONFIG_({ url: post + "/" + id, method: "DELETE" });
    dispatch({ type: "LOADING_MODUL_MODUL" });
    CONNECTION(config)
      .then(response => {
        const { status } = response;
        if (status === 200) {
          return dispatch(actGetDataModul());
        }
        return dispatch({ type: "ERROR_MODUL_MODUL", message: "failed" });
      })
      .catch(response => {
        console.log(response);
        return dispatch({
          type: "ERROR_MODUL_MODUL",
          message: "Network error.."
        });
      });
  };
};
